<template>
  <Collapser :collapserTitle="$t('insuranceDataTile.title')">
    <template #collapserContent>
      <DataBox :data="insuranceDataAsList"></DataBox>
    </template>
  </Collapser>
</template>

<script setup lang="ts">
import { onMounted, type PropType, type Ref, ref } from 'vue'
import {
  Collapser,
  type DataBlock,
  DataBox,
  type SingleBlock
} from 'de-zurich-ui-library'
import { type InsuranceData } from '@/typesTenant/NewVehicleDetailApi'
import { t } from '@/i18n'

const props = defineProps({
  insuranceData: {
    type: Object as PropType<InsuranceData>,
    required: true
  }
})

const insuranceDataAsList: Ref<DataBlock[]> = ref([{ data: [] }])

onMounted(() => {
  fillInsuranceData()
})

function fillInsuranceData() {
  const data: SingleBlock[] = extractDataboxDataFromObject(
    'insuranceDataTile.',
    props.insuranceData
  )
  insuranceDataAsList.value = [{ data }]
}

function extractDataboxDataFromObject(labelTranslatorPrefix: string, object: any) {
  const databoxData: SingleBlock[] = []
  for (const [key, value] of Object.entries<string>(object)) {
    databoxData.push({ label: String(t(labelTranslatorPrefix + key)), value })
  }
  return databoxData
}
</script>
